<template>
  <Dialog
    header="Pagamento em Atraso"
    :visible="visible"
    @update:visible="$emit('update:visible', $event)"
    :style="{ width: '35vw' }"
    :modal="true"
    :closable="false"
  >
    <p style="text-align: justify">
      Sua conta está com o pagamento em atraso, regularize seu pagamento até o
      dia {{ getDueDate() }} caso contrario sua conta ficará inadimplente e seu
      acesso será suspenso até a regularização.
    </p>
    <template #footer>
      <Button label="Fechar" class="p-button-warning" @click="$emit('update:visible', false)" />
    </template>
  </Dialog>
</template>

<script>
export default {
  name: 'AccountWarningOverdue',
  props: {
    visible: Boolean,
    account: Object,
  },
  methods: {
    getDueDate() {
      return this.account.dueDate
        ? this.$dayjs(this.account.dueDate).add(14, 'day').format('DD/MM/YYYY')
        : null;
    },
  },
};
</script>

<style scoped>
</style>